import { useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../../shared/components/button/CreateButtonTrigger";
import { useTranslation } from "react-i18next";
import CreateClientPlatformMarginForm from "./CreateClientPlatformMarginForm";

const CreateClientPlatformMarginDialog = ({
  onSubmitHandler,
  clients,
  platforms,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title={t("clientPlatformMargins.createForm.title")}
      description={t("clientPlatformMargins.createForm.description")}
      content={
        <CreateClientPlatformMarginForm
          onSubmitHandler={onSubmit}
          clients={clients}
          platforms={platforms}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateClientPlatformMarginDialog;
